import {useCheckFeature} from "@/composables/useCheckFeature";
import {storeToRefs} from "pinia";
import {useAuth} from "@/stores/AuthStore";

const routeFeatureMap = {
    'benefitDefinitions': 'benefits',
    'benefitsDashboard': 'benefits',
};

export const checkFeatureGuard = async (to, from, next) => {
    const { organization } = storeToRefs(useAuth());
    const { loadMemberFeatures } = useCheckFeature();

    const features = await loadMemberFeatures(organization.value.slug);

    if(features) {
        const featureKey = routeFeatureMap[to.name] || to.name;

        if(Object.hasOwn(features, featureKey)) {
            const value = features[featureKey];

            if(value && value !== 'off') {
                return next();
            }
            return next('/feature-unavailable');
        }
    }
    return next();
};
